import { useEffect } from "react";
import { Link } from "react-router-dom";
import { HandHeart } from "lucide-react";
import HeroCarousel from "@/components/home/HeroCarousel";
import CharismSection from "@/components/home/CharismSection";
import QuoteBand from "@/components/home/QuoteBand";
import BrothersPreview from "@/components/home/BrothersPreview";

export default function Home() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div data-testid="home-page">
      {/* HERO */}
      <HeroCarousel />

      {/* CHARISM */}
      <CharismSection />

      {/* QUOTE BAND */}
      <QuoteBand />

      {/* BROTHERS PREVIEW */}
      <BrothersPreview />

      {/* CTA */}
      <section className="py-24 bg-brand-green" data-testid="home-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl sm:text-5xl text-brand-bg leading-tight mb-6">
            Become part of a place people can belong to
          </h2>
          <p className="text-brand-bg/75 text-lg mb-10 max-w-2xl mx-auto">
            Walk with us in presence, prayer, and partnership as we accompany men returning from
            Florida&apos;s prisons into a waiting community.
          </p>
          <Link
            to="/support"
            data-testid="home-cta-btn"
            className="inline-flex items-center gap-2 bg-brand-sand text-brand-ink hover:bg-brand-bg px-10 py-4 rounded-full font-medium transition-all duration-300"
          >
            Get Involved <HandHeart className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
